import React from "react";
import PropTypes from "prop-types";
import Delta from "./Delta";
import "./index.scss";

const Item = (props) => {
  const {
    handleMouseDown,
    handleClickVideo,
    name,
    url,
    position,
    text,
    JPG_2X,
    i,
  } = props;

  return (
    <div
      className={`GC-V-I GC-V-I_i${i + 1}`}
      onMouseDown={handleMouseDown}
      onMouseUp={(e) => handleClickVideo(e, url)}
    >
      <div className="GC-V-I__screen">
        <div className="GC-V-I__play">
          <Delta />
        </div>
        <img src={JPG_2X} alt="" loading="lazy" />
      </div>
      <div className="GC-V-I__name">{name}</div>
      <div className="GC-V-I__position">{position}</div>
      <div className="GC-V-I__text">{text}</div>
    </div>
  );
};

Item.propTypes = {
  setUrlYoutubeModal: PropTypes.func,
};

export default Item;
